<template>
  <img :src="require(`../assets/icons/${name}.svg`)" :alt="alt" :width="size" :height="size" v-on="$listeners"/>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true,
    },
    alt: String,
    size: {
      type: String,
      default: 'auto',
    },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/helpers";

img {
  @include disable-drag;
  @include disable-selection;
}
</style>
